import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, autorunAsync } from 'mobx';
import Modal from '../../Modal';
import Form, {FormBody, FormActions, TextInput, SelectInput, CheckBoxInput} from '../../Form';

@inject('aggregationStore', 'stationStore')
@observer
class AggregationAdd extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  };

  @observable aggregation = {
    aggregation_method_id: null,
    source_series_id: null,
    out_series_id: null,
    interval_id: null,
    use_suspicious: true,
    starting_time: '00:00',
  };
  @observable aggregationMethods = [];
  // disposer;

  slug;
  title = 'Add Aggregation';

  constructor(props) {
    super(props);

    this.reset();
    this.handleSave = this.handleSave.bind(this);
  }

  @action reset() {
    const { params: { id } } = this.props;

    this.slug = `/station/${id}/aggregation`;
  }

  componentWillMount() {
    const { params: { id }, aggregationStore, stationStore } = this.props;
  }

  componentWillUnmount() {
    // this.disposer();
  }

  @action onChangeAggregationMethod = e => this.aggregation.aggregation_method_id = +e.target.value;
  @action onChangeSourceDataSeries = e => this.aggregation.source_series_id = +e.target.value;
  @action onChangeOutDataSeries = e => this.aggregation.out_series_id = +e.target.value;
  @action onChangeInterval = e => this.aggregation.interval_id = e.target.value;
  @action onChangeUseSuspicious = e => this.aggregation.use_suspicious = !this.aggregation.use_suspicious;
  @action onChangeStartingTime = e => this.aggregation.starting_time = e.target.value;

  handleSave(e) {
    e.preventDefault();

    const { params: { id }, aggregationStore} = this.props;
    const { notify } = this.context;
    // console.log(this.aggregation)
    aggregationStore.createAggregationItem(this.aggregation, id)
      .then(() => {
        this.context.router.push(this.slug);
        notify.success({ message: 'Created Aggregation' });
      })
      .catch(action((err) => { notify.error(err); }));
  }


  render() {
    const { params: { id }, aggregationStore, dataSeriesItems} = this.props;
    return (
      <Modal title={this.title} slug={this.slug}>
        <Form>
          <FormBody>
            <SelectInput
              label={'Aggregation Method'}
              fields={{ label: 'name', value: 'id' }}
              options={aggregationStore.aggregationMethods}
              onChange={this.onChangeAggregationMethod}
              value={this.aggregation.aggregation_method_id}
            />
            <SelectInput
              label={'Source Data Series'}
              fields={{ label: 'name', value: 'id' }}
              options={dataSeriesItems}
              value={this.aggregation.source_series_id}
              onChange={this.onChangeSourceDataSeries}
            />
            <SelectInput
              label={'Out Data Series'}
              fields={{ label: 'name', value: 'id' }}
              options={dataSeriesItems}
              value={this.aggregation.out_series_id}
              onChange={this.onChangeOutDataSeries}
            />
            <SelectInput
              label={'Aggregation Interval'}
              fields={{ label: 'name', value: 'id' }}
              options={this.props.interval}
              onChange={this.onChangeInterval}
              value={this.aggregation.interval_id}
            />
            <CheckBoxInput label='Use Suspicious' checked={this.aggregation.use_suspicious} onChange={this.onChangeUseSuspicious}/>
            <TextInput
              label={'Starting Time'}
              value={this.aggregation.starting_time}
              onChange={this.onChangeStartingTime}
              readOnly={this.aggregation.interval !== 'DAILY'}
            />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default AggregationAdd;



// WEBPACK FOOTER //
// ./src/components/Station/Aggregation/AggregationAdd.js